import React from "react";
import { RenderComponent } from "@/src/views/RenderComponent";
export function DownloadCenterCategoryBlock(props) {
    var _a;
    return (React.createElement(React.Fragment, null, (_a = props.data.subcategories.expandedValue) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) { return (React.createElement(RenderComponent, { key: idx, contentLink: item.contentLink })); })));
}
